<template>
  <div class="info-page">
    <div class="info-header">
      <div class="w">
        <div class="header-cont">
          <div class="header-logo">
            <router-link
              :to="{path:'/'}"
            >
              <img
                src="https://img1.jcloudcs.com/portal/jdt-jr/jr_logo2.png"
                alt
                width="201"
                height="68"
              />
            </router-link>
          </div>
          <div></div>
          <div class="header-platform">
            <a
              href="//creator.jr.jd.com/#/login"
              target="_blank"
              clstag="DSGJ|85740"
              >创作者服务平台</a
            >
            <span class="line">|</span>
            <a
              href="//finshop.jd.com"
              target="_blank"
              clstag="DSGJ|85739"
              >京东金店服务平台</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
   name:'InfoHeader'
}
</script>
<style lang="scss" scoped>
.info-page{
  height:164px;
  width:100%;
  background: #16192a url(https://img1.jcloudcs.com/portal/jdt-jr/info_bg.png) no-repeat 50%;
  .info-header{
    position: relative;
    height: 164px;
    width: 1200px;
    margin: auto;
    display: flex;
    align-items: center;
    .header-cont{
      height: 100%;
      width: 1200px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .header-platform{
        a {
              color: #fff;
              font-size: 14px;
              line-height: 20px;
              text-decoration: none;
        }
        .line{
          color: #9d9d9d;
          margin: 0 14px;
        }
      }
    }
}
}
</style>